import { useEffect, useState } from "react"

const SimilarProductsReviewSummary = ({ products }) => {

  const [totalReviews, setTotalReviews] = useState(0)
  const [productsWithReviews, setProductsWithReviews] = useState(0)

  useEffect(() => {
    let newProductsWithReview = 0
    const newTotalReviews = products.reduce((prev, curr) => {
      const currentReviewCount = curr.countOfReviews && !isNaN(parseInt(curr.countOfReviews)) ? parseInt(curr.countOfReviews) : 0
      if (currentReviewCount > 0) {
        newProductsWithReview = newProductsWithReview + 1
      }
      return prev + currentReviewCount
    }, 0)
    setTotalReviews(newTotalReviews)
    setProductsWithReviews(newProductsWithReview)
  }, [products])

  return totalReviews > 0 ? <span className="ml-2">({totalReviews} reviews from {productsWithReviews} products)</span> : null
}

export default SimilarProductsReviewSummary
